import {
  ISourceEntityTypes,
  SourceEntityMigrationType,
} from '@principle-theorem/practice-migrations/interfaces';
import { TypeGuard } from '@principle-theorem/shared';
import { flow, isBoolean, isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { SourceEntity } from '../../../source/source-entity';

export const APPOINTMENT_ROOM_RESOURCE_TYPE = 'appointmentRoom';

export const APPOINTMENT_ROOM_SOURCE_ENTITY = SourceEntity.init({
  metadata: {
    label: 'Appointment Room List',
    description: '',
    idPrefix: APPOINTMENT_ROOM_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export interface IExactAppointmentRoom {
  id: string;
  name: string;
  code: string;
  location_id: string;
  is_active: boolean;
}

function isExactAppointmentRoom(
  item: unknown,
  logError: boolean
): item is IExactAppointmentRoom {
  return TypeGuard.interface<IExactAppointmentRoom>(
    {
      id: isString,
      name: isString,
      code: isString,
      location_id: isString,
      is_active: isBoolean,
    },
    logError
  )(item);
}

const APPOINTMENT_ROOM_SOURCE_QUERY = `
  SELECT
    id::TEXT,
    name,
    code,
    isactive AS is_active,
    locationid::TEXT AS location_id
  FROM
    convappointmentroom
`;

export type ExactAppointmentRoom = ISourceEntityTypes<IExactAppointmentRoom>;

export class AppointmentRoomSourceEntity extends BaseSourceEntity<ExactAppointmentRoom> {
  sourceEntity = APPOINTMENT_ROOM_SOURCE_ENTITY;
  entityResourceType = APPOINTMENT_ROOM_RESOURCE_TYPE;
  sourceQuery = APPOINTMENT_ROOM_SOURCE_QUERY;
  verifySourceFn = isExactAppointmentRoom;
  override transformDataFn = flow([]);

  translate(): object {
    return {};
  }

  getSourceRecordId(data: IExactAppointmentRoom): string {
    return data.id;
  }

  getSourceLabel(data: IExactAppointmentRoom): string {
    return `${data.id} ${data.name}`;
  }
}
